import APPCONFIG from '../../constants/Config';
import {
  GET_OPERATORS,
  GET_OPERATORS_SUCCESS,
  GET_OPERATORS_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/operator';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.operator;
const operator = (state = initialSettings, action) => {
  let operators;
  switch (action.type) {
    case GET_OPERATORS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: null,
        },
      };
    case GET_OPERATORS_SUCCESS:
      operators = deserialize(action.data.data);
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: operators,
        },
      };
    case GET_OPERATORS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default operator;



// WEBPACK FOOTER //
// ./reducers/operator/operator.js